<div [formGroup]="form">
  <table [id]="field.QuestionID" cellspacing="1" cellpadding="3" style="border: 1px solid; height: 100%; width: 100%;">
    <tr>
      <td colspan="2" rowspan="2" style="width: 30%;">&nbsp;</td>
      <td align="center" [attr.colspan]="field.MatrixQuestion.HMatrixRows.MatrixElements.length" style="background-color:Gray;"><strong>{{field.MatrixQuestion.HMatrixRows.QuestionDefGroupName}}</strong></td>
    </tr>
    <tr>
      <td style="background-color: LightGrey;" *ngFor="let data of field.MatrixQuestion.HMatrixRows.MatrixElements"><strong>{{data.QuestionDefText}}</strong></td>
    </tr>
    <tr *ngFor="let data of matrixAnsData;">
      <ng-container *ngIf="data.index == 0">
        <td valign="middle" [attr.rowspan]="field.MatrixQuestion.VMatrixRows.MatrixElements.length" style="background-color:Gray;"><strong>{{field.MatrixQuestion.VMatrixRows.QuestionDefGroupName}}</strong></td>
      </ng-container>
      <td style="background-color:LightGrey; border-bottom:1px solid;"><strong>{{field.MatrixQuestion.VMatrixRows.MatrixElements[data.index].QuestionDefText}}</strong></td>
      <ng-container *ngFor="let ans of data.answers;">
        <td style="height:20%;width:10%;">
          <div class="matrix-control" [ngClass]="{'input-validation-error': isTouched && isInValid }">
            <input type="checkbox" [checked]="ans.checked" [id]="ans.uniquename" [value]="ans.FormAnswerDefID" (change)="onCheckboxChange($event)" [disabled]="field.controlDisabled" />
            <label class="d-block m-0 p-1" [for]="ans.uniquename">
              {{ans.AnswerDefText}}
            </label>
          </div>
        </td>
      </ng-container>
    </tr>
  </table>
</div>
<style>
  .matrix-control input {
    position: absolute;
    z-index: -1;
    opacity: 0;
    left: -9999px;
  }
  .matrix-control label {
   cursor:pointer;
  }
  .matrix-control input[disabled] ~ label {
    cursor: default;
  }
  .matrix-control input:checked ~ label {
    background-color: #00679A;
    color: #fff;
  }
</style>
